<!-- Global system message ribbon used across login flows -->
<app-system-message class="systemMessage"></app-system-message>

<div class="container-fluid" [ngClass]="theme.getThemeClass()">
  <!-- Loading overlay while session is being checked or actions are in-flight -->
  @if (loading) {
  <app-loading-element
    class="container-fluido componentBelow"
  ></app-loading-element>
  }

  <!-- Login form -->
  @if (view === LoginView.Login) {
  <app-login-login-form [ctx]="this" [loading]="loading"></app-login-login-form>
  }

  <!-- Forgot password (email request) -->
  @if (view === LoginView.ForgotPasswordEmail) {
  <app-login-forgot-password-email [ctx]="this" [loading]="loading"></app-login-forgot-password-email>
  }

  <!-- Forgot password (reset code + new password) -->
  @if (view === LoginView.ForgotPasswordReset) {
  <app-login-forgot-password-reset [ctx]="this" [loading]="loading"></app-login-forgot-password-reset>
  }

  <!-- First-time or forced new password -->
  @if (view === LoginView.NewPassword) {
  <app-login-new-password [ctx]="this" [loading]="loading"></app-login-new-password>
  }

  <!-- Email validation code entry -->
  @if (view === LoginView.EmailValidation) {
  <app-login-email-validation [ctx]="this" [loading]="loading"></app-login-email-validation>
  }

  <!-- Phone validation code entry -->
  @if (view === LoginView.PhoneValidation) {
  <app-login-phone-validation [ctx]="this" [loading]="loading"></app-login-phone-validation>
  }

  <!-- MFA signup (QR + code) -->
  @if (view === LoginView.MfaSignUpQr || view === LoginView.MfaSignUpCode) {
  <app-login-mfa-signup [ctx]="this" [view]="view" [loading]="loading"></app-login-mfa-signup>
  }

  <!-- MFA sign-in code entry -->
  @if (view === LoginView.MfaSignIn) {
  <app-login-mfa-signin [ctx]="this" [loading]="loading"></app-login-mfa-signin>
  }
</div>
